<template>
    <div class="sheetBatchUpdateModal">
        <dsh-modal
            class="sheetBatchUpdateModal-modal"
            v-model="showModal"
            :mode="modalPropsObj.mode"
            :propsObj="modalPropsObj"
        >
            <div class="wrap">
                <!-- 标题 -->
                <p class="wrap-desc">选择需要修改的字段，列表中所有该字段的值将被批量修改</p>

                <!-- 内容 -->
                <div class="wrap-content">
                    <div class="wrap-content-field">
                        <label>
                            <span v-if="batchUpdateFormItem._required">*</span>
                            修改字段
                        </label>
                        <dsh-select
                            :value="selectFieldObj"
                            :propsObj="selectFieldPropsObj"
                        ></dsh-select>
                    </div>

                    <div
                        class="wrap-content-val"
                        :style="{
                            visibility: selectFormList.length ? 'visible' : 'hidden'
                        }"
                    >
                        <label>字段内容</label>
                        <div style="flex: 1; min-width: 0px;">
                            <dsh-select
                                class="wrap-content-val-radio"
                                :value="selectFieldObj"
                                :propsObj="batchUpdateRadioPropsObj"
                            ></dsh-select>
                            <dsh-formItem
                                class="wrap-content-val-formItem"
                                :formData="batchUpdateFormData"
                                :formItem="batchUpdateFormItem"
                            ></dsh-formItem>
                        </div>
                    </div>
                </div>

                <!-- 按钮 -->
                <dsh-buttons
                    class="wrap-btns"
                    :list="$getOperationList(['cancel', 'confirm'])"
                    @click="$dispatchEvent($event)"
                ></dsh-buttons>
            </div>
        </dsh-modal>
    </div>
</template>

<script>
    export default {
        name: "sheetBatchUpdateModal",
        props: {
            companyId: String,
            appId: String,
            modKey: String,
            screenKey: String,

            value: Boolean,
            dataIds: {
                type: Array,
                default () {
                    return [];
                }
            },
            formList: {
                type: Array,
                default () {
                    return [];
                }
            }
        },
        data () {
            return {
                modalPropsObj: {
                    mode: "middle",
                    title: "批量修改",
                    width: "960",
                    class: "",
                    maskClosable: false,
                    footerHide: true
                },

                urlParams: {
                    module: "sheet",
                    name: "index"
                },
                selectFieldObj: {
                    fieldKey: "", // select 字段类型
                    setNull: 0 // radio 清空内容
                },
                batchUpdateFormData: {},
                fieldBatchUpdateMap: this.$getModFieldPropertyMap("canBatchUpdate")
            };
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (bool) {
                    this.$emit("input", bool);
                }
            },
            // 批量编辑
            batchUpdateFormItem () {
                return {...this.selectFormList[0], _noLabel: true, _span: 24, canEdit: !this.selectFieldObj.setNull};
            },
            selectFormList () {
                return this.formList.filter(item => item._key === this.selectFieldObj.fieldKey);
            },
            batchUpdateRadioPropsObj () {
                return {
                    _name: "字段",
                    _key: "setNull",
                    _optionKind: "flat",
                    _data: [
                        {
                            _key: 0,
                            name: "修改为新值"
                        },
                        {
                            _key: 1,
                            name: "清空内容",
                            _disabled: this.batchUpdateFormItem._required
                        }
                    ]
                };
            },
            selectFieldPropsObj () {
                return {
                    _name: "字段",
                    _key: "fieldKey",
                    _optionKind: "dropdown",
                    _data: this.formList.filter(item => item.canEdit && this.fieldBatchUpdateMap[item._type])
                };
            },

            operationMap () {
                return {
                    // 批量编辑弹窗按钮
                    confirm: {
                        name: "确认",
                        type: "confirm",
                        btnType: "primary",
                        size: "large",
                        event: "handleBatchUpdate"
                    },
                    cancel: {
                        name: "取消",
                        type: "cancel",
                        btnType: "default",
                        size: "large",
                        event: "clickCancel"
                    }
                };
            }
        },
        created () {
            this.getModData();
        },
        methods: {
            getModData (name) {
                this.$https({
                    url: {
                        ...this.urlParams,
                        name: "default"
                    },
                    params: {
                        _id: this.$ObjectID().str,
                        screenKey: this.screenKey
                    },
                    callback: data => {
                        this.batchUpdateFormData = data;
                    }
                });
            },
            // 接口-批量编辑
            handleBatchUpdate (operationItem, dataItem, dataIndex) {
                if (!this.selectFieldObj.fieldKey) {
                    this.$Message.error("请先选择“修改字段”");
                    return;
                }
                this.$https({
                    url: {
                        ...this.urlParams,
                        name: "searchUpdate"
                    },
                    params: {
                        screenKey: this.screenKey,
                        search: {
                            _id: {
                                "$in": this.dataIds
                            }
                        },
                        updateParams: {
                            [this.selectFieldObj.fieldKey]: this.batchUpdateFormData[this.selectFieldObj.fieldKey]
                        }
                    },
                    callback: data => {
                        this.showModal = false;
                        this.$emit("batchUpdateCb", data);
                    }
                });
            },
            // 取消批量编辑
            clickCancel () {
                this.showModal = false;
            }
        },
        watch: {
            "selectFieldObj.setNull": {
                handler (newV, oldV) {
                    let key = this.selectFieldObj.fieldKey;
                    newV && (Array.isArray(this.batchUpdateFormData[key]) ? (this.batchUpdateFormData[key] = []) : (this.batchUpdateFormData[key] = null));
                },
                immediate: true
            },
            "selectFieldObj.fieldKey": {
                handler (newV, oldV) {
                    // 字段必填时不能置空
                    this.batchUpdateFormItem._required && (this.selectFieldObj.setNull = 0);
                },
                immediate: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/operation/update/sheetBatchUpdateModal.vue